import React from "react";

export const GameSkeletonLoading = ({ count = 24, isLiveGame }) => {
  return (
    <div className="hidden md:flex gap-3">
       {
         !isLiveGame && 
      <div className="w-[240px] bg-[#1b1b1c] py-4 px-2 border-r border-[#252526]">
       <div className="w-full animate-pulse space-y-4">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="h-6 w-full bg-gray-700 rounded px-2"></div>
          ))}
        </div>
      </div>
       } 

      <div className="relative min-w-[calc(100%-170px)] w-full flex flex-wrap bg-[#353a45] justify-center items-center gap-4 p-2 pb-30">
        {Array.from({ length: count }).map((_, index) => (
          <div
            key={index}
            className="max-w-[180px] w-full self-stretch animate-pulse"
          >
            <div className="bg-gray-700 rounded-lg w-full h-[90px]"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export const MobileGameSkeletonLoading = () => {
  return (
    <>
      {[...Array(3)].map((_, index) => (
        <div key={index} className="mt-3">
          <div className="flex justify-between items-center px-4 py-2 bg-[#0c0d0e] rounded-md">
            <div className="bg-gray-700 rounded w-32 h-4 animate-pulse" />
            <div className="bg-gray-700 rounded w-16 h-4 animate-pulse" />
          </div>

          <div className="bg-[#0c0d0e] px-4 py-3">
            <div className="flex gap-3 overflow-x-auto">
              {[...Array(6)].map((_, idx) => (
                <div
                  key={idx}
                  className="min-w-[160px] h-[90px] rounded-lg bg-gray-800 animate-pulse"
                />
              ))}
            </div>
          </div>
        </div>
      ))}
    </>
  )
}

